import React, { useEffect, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { getProfile } from "../../../data";
import AuthStore from "../../../stores/AuthStore";
import { Button } from "@/components/ui/button";
import { Sidebar, MobileSidebar } from "./sidebar";

export const AppLayout = (props) => {
  const [fistTimeForMount, setFistTimeForMount] = useState(true);
  const { data, isSuccess } = useQuery({
    queryKey: ["profile"],
    queryFn: getProfile,
  });

  useEffect(() => {
    if (isSuccess && data?.data) {
      if (fistTimeForMount) {
        // Backend returns user directly, not wrapped in { user: ... }
        AuthStore.setProfile(data.data);
      }
      setFistTimeForMount(false);
    }
  }, [isSuccess, data]);

  if (props.loading) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-background">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-background">
      <div className="flex">
        {/* Desktop Sidebar */}
        <div className="hidden md:flex w-64 flex-col fixed inset-y-0 z-50">
          <Sidebar />
        </div>

        {/* Main Content */}
        <div className="flex-1 md:pl-64 flex flex-col min-h-screen">
          {/* Header */}
          <header className="sticky top-0 z-40 flex h-20 items-center gap-x-4 border-b bg-background/80 backdrop-blur-xl px-6 shadow-sm sm:gap-x-6 lg:px-8">
            <MobileSidebar />

            <div className="flex flex-1 gap-x-4 self-stretch lg:gap-x-6">
              <div className="flex flex-1 items-center gap-3">
                <h1 className="text-2xl font-bold text-foreground">
                  {props.title}
                </h1>
                {props.description && (
                  <span className="hidden lg:block text-sm text-muted-foreground">
                    {props.description}
                  </span>
                )}
              </div>
              <div className="flex items-center gap-3">
                {/* Actions from props */}
                {props.actions?.map((item, index) => (
                  <Button
                    key={index}
                    onClick={item.onClick}
                    variant={item.variant || "default"}
                    className={item.className}
                    size="default"
                  >
                    {item.icon && <span className="mr-2">{item.icon}</span>}
                    {item.name}
                  </Button>
                ))}
              </div>
            </div>
          </header>

          {/* Page Content */}
          <main className="flex-1 py-8">
            <div className="px-6 lg:px-8 max-w-7xl mx-auto">
              <div className="animate-in fade-in slide-in-from-bottom-4 duration-500">
                {props.children}
              </div>
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};
